import React, { useEffect, useState } from "react";
import "../styles/InfoCard.scss";

const InfoCard = ({ unit, showDelta, dataTitle, dataSubTitle, currentData, historicalData, timeRange, hasCustomerMaps }) => {
  const [deltaStr, setDeltaStr] = useState(null);
  const [deltaPercentStr, setDeltaPercentStr] = useState(null);
  const [unitFormated, setUnitFormated] = useState("");
  const [currentDataFormated, setCurrentDataFormated] = useState("");

  useEffect(() => {}, []);

  useEffect(() => {
// 1. Parse currentData dynamically
    if (currentData === null || currentData === undefined) {
      setCurrentDataFormated("—");
      setDeltaStr("—");
      setDeltaPercentStr("");
      return;
    }

    const curr = String(currentData).includes(".") ? parseFloat(currentData).toFixed(2) : parseInt(currentData, 10);
    const hist = String(historicalData).includes(".") ? parseFloat(historicalData).toFixed(2) : parseInt(historicalData, 10);

setCurrentDataFormated(isNaN(curr) ? "—" : curr)

    // update currentdata
if(unit === "bytes"){
  formatBytes(currentData)
}

  
    // if either value isn't a number, bail out
    if (isNaN(curr) || isNaN(hist)) {
      setDeltaStr("—");
      setDeltaPercentStr("");
      return;
    }
  
    // compute the absolute delta
    const diff = curr - hist;
    setDeltaStr(diff > 0
      ? `+${formatWithSpaces(diff)}`
      : diff < 0 ? `${formatWithSpaces(diff)}` : `unchanged`
    );
  
    // guard against zero-denominator
    if (hist === 0) {
      setDeltaPercentStr("(0.00%)");
    } else {
      const percnt = ((curr / hist - 1) * 100).toFixed(2);
      setDeltaPercentStr(`(${formatWithSpaces(percnt)}%)`);
    }
  }, [currentData, historicalData]);
  


/**
 * Formats a number (or numeric string) with spaces as thousand separators,
 * preserving an existing decimal part (comma or dot). 
 * Returns the string "NaN" if the input isn't a valid integer or decimal.
 *
 * @param {number|string} value
 * @returns {string}
 */
function formatWithSpaces(value) {
  let str = String(value).trim();
  let sign = "";
  if (/^[+-]/.test(str)) {
    sign = str[0];
    str = str.slice(1);
  }

  str = str.replace(/\s+/g, "");


  if (!/^\d+(?:[.,]\d+)?$/.test(str)) {
    return "—";
  }

  let sep = "";
  let intPart = str;
  let fracPart = "";
  if (str.includes(",") || str.includes(".")) {
    const lastComma = str.lastIndexOf(",");
    const lastDot   = str.lastIndexOf(".");
    sep = lastComma > lastDot ? "," : ".";
    const idx = str.lastIndexOf(sep);
    intPart  = str.slice(0, idx);
    fracPart = str.slice(idx + 1);
  }

  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return sign + intPart + (fracPart ? sep + fracPart : "");
}


//helper func to convert bytes to kilobytes or megabytes
const formatBytes = (dataString) => {
  const bytes = parseFloat(dataString);
  // Handle cases where the string isn't a valid number
  if (isNaN(bytes)) {
    setCurrentDataFormated("0.00");
    setUnitFormated("b");
    return;
  }
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  // Determine the magnitude (0 for b, 1 for kb, 2 for mb, etc.)
  // We use Math.log to find the power of 1000 the number reaches
  let index = Math.floor(Math.log(Math.abs(bytes)) / Math.log(1000));
  // Ensure we don't go out of bounds of our units array
  index = Math.max(0, Math.min(index, units.length - 1));
  // Calculate the value based on the index
  const value = bytes / Math.pow(1000, index);
  // Set the states
  setCurrentDataFormated(value.toFixed(2));
  setUnitFormated(units[index]);
};

  return (
    <div className="ic-main-container">
      <span className="ic-top-span1">{dataTitle}</span>
      <span className="ic-top-span2">{dataSubTitle}</span>
     <div className="ic-spacer"></div>

 { showDelta && <div className="ic-bot-div">
        <span
          className={`ic-bot-span1 ${
            deltaStr?.[0] === "+"
              ? "ic-green-text"
              : deltaStr?.[0] === "-"
              ? "ic-red-text"
              : "ic-grey-text"
          }`}
        >
          {deltaStr} {deltaPercentStr}
        </span>

        {timeRange === "1M" &&<span className="ic-bot-span2">past month</span>}
        {timeRange === "3M" &&<span className="ic-bot-span2">past 3 months</span>}
        {timeRange === "6M" &&<span className="ic-bot-span2">past 6 months</span>}
        {timeRange === "YTD" &&<span className="ic-bot-span2">year to date</span>}
        {timeRange === "Max" &&<span className="ic-bot-span2">all time</span>}
      </div>}

     { unit === "bytes" ? <span className="ic-mid-span">{currentDataFormated} <span> {unitFormated}</span></span> : <span className="ic-mid-span">{currentDataFormated}</span>}
     
      
    </div>
  );
};

export default InfoCard;
